module.exports = __webpack_public_path__ + "static/media/logo.71ffb0ef.svg";